<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
    <a-modal title="对公转账审核" :width="1100" :open="true" :confirmLoading="state.submitLoading" :maskClosable="false"
        @cancel="cancel">
        <template #footer>
            <a-button @click="cancel">取消</a-button>
            <a-popconfirm title="是否确定？" @confirm="onFormSubmit">
                <a-button type="primary" :loading="state.submitLoading">确定</a-button>
            </a-popconfirm>
        </template>

        <a-skeleton :loading="state.loading" active :paragraph="{ rows: 6 }">
            <a-form ref="ruleForm" :model="formState" v-bind="formLayout">
                <a-form-item label="提交人姓名">
                    {{ detailData.submit_operator_admin_info?.nickname || '--' }} ； 付款金额：{{ detailData.money || '--' }}
                    ；类型：
                    <span v-if="detailData.buss_type == 3">刻章-对公转账</span>
                    <span v-if="detailData.buss_type == 2">地址-对公转账</span>
                </a-form-item>
                <a-form-item label="付款备注：" v-if="detailData.remark">{{ detailData.remark }}</a-form-item>
                <a-form-item label="其他收入：" v-if="detailData.other_name">
                    {{ detailData.other_name }}【{{ detailData.other_amount }}】
                </a-form-item>
                <a-form-item label="附件：">
                    <div v-if="detailData.attachment">
                        <span v-for="(item, index) in detailData.attachment" :key="index">
                            <a-image v-if="isImage(item.name)" :width="120" :height="50"
                                :src="$store.state.user.image_domain + item.url" />
                            <p v-else>
                                <a :href="$store.state.user.image_domain + item.url" target="_blank">{{ item.name }}</a>
                            </p>
                        </span>
                    </div>
                </a-form-item>

                <a-form-item label="公司名称">
                    <div v-for="(item, index) in distributionList" :key="index">
                        {{ item.full_name }} ￥{{ Number(item.money || 0).toFixed(2) }}元
                    </div>
                    <span v-if="detailData.payment_type == 1">【支付注册费】</span>
                    <span v-if="detailData.payment_type == 2">【地址续费】</span>
                    <span v-if="detailData.payment_type == 3">【其他收入】</span>
                    <div style="font-weight: bold; margin-top: 4px;">
                        总计：￥{{ Number(detailData.zong_money || 0).toFixed(2) }}元
                    </div>
                </a-form-item>

                <div v-if="detailData.buss_type == 2 && detailData.payment_type == 2">
                    <a-form-item label="收费类型">
                        <span v-if="detailData.fee_standard == 1">按年续费</span>
                        <span v-if="detailData.fee_standard == 2">一次性</span>
                        <span> ；续费时长：{{ detailData.month_amount }} 月</span>
                    </a-form-item>
                </div>

                <a-form-item label="审核结果" :required="true">
                    <a-radio-group v-model:value="formState.status" button-style="solid">
                        <a-radio :value="1">通过</a-radio>
                        <a-radio :value="2">不通过</a-radio>
                    </a-radio-group>
                </a-form-item>

                <!-- 付款金额：可编辑，有分配列表时联动最后一条 -->
                <a-form-item label="付款金额" v-if="formState.status == 1">
                    <a-input-number v-model:value="formState.money" :precision="2" placeholder="请输入转账金额" addonAfter="元"
                        style="width: 180px" @change="onTotalMoneyChange" />
                </a-form-item>

                <!-- 分配方案：审核通过 + 有分配列表才显示 -->
                <template v-if="needDistribution">
                    <a-divider orientation="left">分配方案</a-divider>
                    <div class="distribution-wrapper">
                        <div class="distribution-row distribution-header">
                            <div class="col-company">公司名称</div>
                            <div class="col-money">付款金额</div>
                            <div class="col-money">平台分配</div>
                            <div class="col-money">代理商分配</div>
                            <div class="col-money">代理商上级分配</div>
                            <div class="col-money">服务商分配(自动)</div>
                            <div class="col-action">快捷操作</div>
                        </div>
                        <div class="distribution-row" v-for="(item, index) in distributionList" :key="index">
                            <div class="col-company" :title="item.full_name">{{ item.full_name }}</div>
                            <div class="col-money">
                                <a-input-number v-model:value="item.money" :precision="2" style="width: 100%"
                                    @focus="onRowMoneyFocus(index)" @change="onRowMoneyChange(index)" />
                            </div>
                            <div class="col-money">
                                <a-input-number v-model:value="item.distribut_platform" :precision="2"
                                    style="width: 100%" />
                            </div>
                            <div class="col-money">
                                <a-input-number v-model:value="item.distribut_seller" :precision="2"
                                    style="width: 100%" />
                            </div>
                            <div class="col-money">
                                <a-input-number v-model:value="item.distribut_dealer" :precision="2"
                                    style="width: 100%" />
                            </div>
                            <div class="col-money">
                                <span :style="{ color: rowFwsMoney(item) < 0 ? 'red' : '#333' }">
                                    ￥{{ rowFwsMoney(item).toFixed(2) }}
                                </span>
                            </div>
                            <div class="col-action">
                                <a @click="fillAllToPlatform(index)">全给平台</a>
                                <a-divider type="vertical" />
                                <a @click="fillPlatformHalf(index)">平台分一半</a>
                                <a-divider type="vertical" />
                                <a @click="clearRow(index)">清空</a>
                            </div>
                        </div>
                        <div class="distribution-row distribution-footer">
                            <div class="col-company">合计</div>
                            <div class="col-money">
                                <span class="red">￥{{ totalPayMoney.toFixed(2) }}</span>
                            </div>
                            <div class="col-money">￥{{ totalPlatform.toFixed(2) }}</div>
                            <div class="col-money">￥{{ totalSeller.toFixed(2) }}</div>
                            <div class="col-money">￥{{ totalDealer.toFixed(2) }}</div>
                            <div class="col-money">
                                <span :style="{ color: totalFws < 0 ? 'red' : '#333' }">
                                    ￥{{ totalFws.toFixed(2) }}
                                </span>
                            </div>
                            <div class="col-action">
                                <span v-if="hasOverflow" style="color: red;">存在超额/负数，请检查</span>
                            </div>
                        </div>
                    </div>
                </template>

                <a-form-item label="备注" style="margin-top: 16px;">
                    <a-textarea v-model:value="formState.remark" placeholder="请输入备注" style="width: 400px" />
                </a-form-item>
            </a-form>
        </a-skeleton>
    </a-modal>
</template>

<script lang="ts" setup name="createTemplate">
import { reactive, ref, onMounted, computed } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import { useStore } from 'vuex'

const $store = useStore()
const emit = defineEmits(['ok', 'cancel'])
const props = defineProps({
    detailData: {
        type: Object,
        default: () => ({})
    }
})

const formLayout = {
    labelCol: { xs: { span: 4 }, sm: { span: 4 } },
    wrapperCol: { xs: { span: 18 }, sm: { span: 18 } }
}

const state = reactive({
    loading: false,
    submitLoading: false,
})

interface FormStateIface {
    id: number
    status: number
    money: number
    remark: string
}
const formState = reactive<FormStateIface>({
    id: 0,
    status: 1,
    money: 0,
    remark: ''
})

// 合并后的详情：props.detailData（详情） + auditInit（zong_money / distribution_list）
const detailData = ref<any>({})

// 分配方案
interface DistributionItem {
    customer_id?: number
    full_name: string
    money: number
    distribut_platform: number
    distribut_seller: number
    distribut_dealer: number
}
const distributionList = ref<DistributionItem[]>([])

// 行 money 输入前的快照（用于算差额）
const rowMoneySnapshot = ref<number>(0)

const isImage = (name: string) => {
    if (!name) return false
    const n = name.toLowerCase()
    return n.includes('jpg') || n.includes('png') || n.includes('jpeg')
}

// 是否需要显示分配方案：审核通过 + 有分配列表
const needDistribution = computed(() => {
    if (formState.status != 1) return false
    return distributionList.value.length > 0
})

// 初始化
const initDetail = () => {
    const id = props.detailData?.id
    if (!id) return
    state.loading = true
    baseService({
        url: '/admin/v1/publicARecharge/auditInit',
        method: 'post',
        data: { id }
    })
        .then((res: any) => {
            const data = res.data || {}
            detailData.value = {
                ...props.detailData,
                zong_money: data.zong_money,
                distribution_list: data.distribution_list || []
            }
            formState.id = props.detailData.id
            initDistributionList()

            // 有列表：总金额 = 表格合计；空列表：用 zong_money，不求和
            if (distributionList.value.length > 0) {
                formState.money = Number(totalPayMoney.value.toFixed(2))
            } else {
                formState.money = Number(data.zong_money ?? props.detailData.money ?? 0)
            }
        })
        .catch((res: any) => {
            message.error(res?.msg || '获取审核初始化数据失败')
        })
        .finally(() => {
            state.loading = false
        })
}

const initDistributionList = () => {
    const list = detailData.value.distribution_list || []
    distributionList.value = list.map((item: any) => ({
        customer_id: item.customer_id,
        full_name: item.full_name,
        money: Number(item.money || 0),
        distribut_platform: Number(item.distribut_platform || 0),
        distribut_seller: Number(item.distribut_seller || 0),
        distribut_dealer: Number(item.distribut_dealer || 0)
    }))
}

// 服务商剩余 = 该行 money - 三项（实时算，money 变自动变）
const rowFwsMoney = (item: DistributionItem) => {
    const val = Number(item.money || 0)
        - Number(item.distribut_platform || 0)
        - Number(item.distribut_seller || 0)
        - Number(item.distribut_dealer || 0)
    return Number(val.toFixed(2))
}

// ---------------- 总金额 ↔ 表格金额 联动 ----------------

// 改总金额：差额落到最后一条（空列表不联动）
const onTotalMoneyChange = () => {
    const list = distributionList.value
    if (!list.length) return
    const newTotal = Number(formState.money || 0)

    // 只有一条：直接等于总金额
    if (list.length === 1) {
        list[0].money = Number(newTotal.toFixed(2))
        return
    }

    const frontSum = list.slice(0, -1).reduce((s, i) => s + Number(i.money || 0), 0)
    const last = list[list.length - 1]
    // 允许为负，提交时校验
    last.money = Number((newTotal - frontSum).toFixed(2))
}

// 行 money 聚焦：记旧值
const onRowMoneyFocus = (index: number) => {
    rowMoneySnapshot.value = Number(distributionList.value[index]?.money || 0)
}

// 行 money 变化：差额落到锚点行
const onRowMoneyChange = (index: number) => {
    const list = distributionList.value
    const item = list[index]
    if (!item) return
    const newVal = Number(item.money || 0)
    const oldVal = rowMoneySnapshot.value
    const delta = Number((newVal - oldVal).toFixed(2))
    if (delta === 0) return

    // 只有一条：总金额 = 该行 money
    if (list.length === 1) {
        formState.money = newVal
        rowMoneySnapshot.value = newVal
        return
    }

    const lastIndex = list.length - 1
    // 改最后一条 → 锚点倒数第二条；否则 → 锚点最后一条
    const anchorIndex = index === lastIndex ? lastIndex - 1 : lastIndex
    const anchor = list[anchorIndex]
    // 锚点减去差额，允许为负
    anchor.money = Number((Number(anchor.money || 0) - delta).toFixed(2))

    // 总金额 = 表格合计
    formState.money = Number(totalPayMoney.value.toFixed(2))
    rowMoneySnapshot.value = newVal
}

// ---------------- 合计 ----------------
const totalPayMoney = computed(() => {
    return distributionList.value.reduce((sum, item) => sum + Number(item.money || 0), 0)
})
const totalPlatform = computed(() => {
    return distributionList.value.reduce((sum, item) => sum + Number(item.distribut_platform || 0), 0)
})
const totalSeller = computed(() => {
    return distributionList.value.reduce((sum, item) => sum + Number(item.distribut_seller || 0), 0)
})
const totalDealer = computed(() => {
    return distributionList.value.reduce((sum, item) => sum + Number(item.distribut_dealer || 0), 0)
})
const totalFws = computed(() => {
    return distributionList.value.reduce((sum, item) => sum + rowFwsMoney(item), 0)
})
const hasOverflow = computed(() => {
    return distributionList.value.some(item => rowFwsMoney(item) < 0 || Number(item.money) < 0)
})

// ---------------- 快捷操作 ----------------
const fillAllToPlatform = (index: number) => {
    const item = distributionList.value[index]
    if (!item) return
    item.distribut_platform = Number(item.money || 0)
    item.distribut_seller = 0
    item.distribut_dealer = 0
}
const fillPlatformHalf = (index: number) => {
    const item = distributionList.value[index]
    if (!item) return
    item.distribut_platform = Number((Number(item.money || 0) / 2).toFixed(2))
    item.distribut_seller = 0
    item.distribut_dealer = 0
}
const clearRow = (index: number) => {
    const item = distributionList.value[index]
    if (!item) return
    item.distribut_platform = 0
    item.distribut_seller = 0
    item.distribut_dealer = 0
}

// ---------------- 提交（统一校验） ----------------
const onFormSubmit = () => {
    if (state.submitLoading) return

    // 1. 总金额 > 0
    if (Number(formState.money) <= 0) {
        message.error('付款金额必须大于 0')
        return
    }

    // 2. 有分配列表时，总金额必须 = 表格 money 合计
    if (distributionList.value.length > 0) {
        const sum = Number(totalPayMoney.value.toFixed(2))
        const total = Number(Number(formState.money).toFixed(2))
        if (Math.abs(sum - total) > 0.001) {
            message.error('付款金额与分配合计不一致，请检查')
            return
        }
    }

    // 3. 每行 money ≥ 0
    for (const item of distributionList.value) {
        if (Number(item.money) < 0) {
            message.error(`「${item.full_name}」的付款金额不能为负数`)
            return
        }
    }

    // 4. 每行三项分配 ≥ 0
    for (const item of distributionList.value) {
        if (Number(item.distribut_platform) < 0
            || Number(item.distribut_seller) < 0
            || Number(item.distribut_dealer) < 0) {
            message.error(`「${item.full_name}」的分配金额不能为负数`)
            return
        }
    }

    // 5. 每行服务商剩余 ≥ 0（即三项 ≤ money）
    for (const item of distributionList.value) {
        if (rowFwsMoney(item) < 0) {
            message.error(`「${item.full_name}」的分配金额合计不能超过该主体的付款金额`)
            return
        }
    }

    state.submitLoading = true
    const submitData: any = {
        id: formState.id,
        status: formState.status,
        money: Number(formState.money),
        remark: formState.remark
    }

    // 有分配列表才带 distribution_list（刻章空列表不带）
    if (needDistribution.value) {
        submitData.distribution_list = distributionList.value.map(item => ({
            customer_id: item.customer_id,
            full_name: item.full_name,
            money: Number(item.money || 0),
            distribut_platform: Number(item.distribut_platform || 0),
            distribut_seller: Number(item.distribut_seller || 0),
            distribut_dealer: Number(item.distribut_dealer || 0)
        }))
    }

    baseService({
        url: '/admin/v1/publicARecharge/audit',
        method: 'post',
        data: submitData
    })
        .then((res: any) => {
            message.success(res.msg)
            emit('ok')
        })
        .catch((res: any) => {
            message.error(res?.msg || '操作失败,请联系管理员')
        })
        .finally(() => {
            state.submitLoading = false
        })
}

const cancel = () => {
    emit('cancel')
}

onMounted(() => {
    initDetail()
})
</script>

<style lang="less" scoped>
.distribution-wrapper {
    border: 1px solid #f0f0f0;
    border-radius: 4px;
    padding: 8px 12px;
    background: #fafafa;
}

.distribution-row {
    display: flex;
    align-items: center;
    padding: 6px 0;
    border-bottom: 1px dashed #eee;
    font-size: 13px;

    &:last-child {
        border-bottom: none;
    }

    >div {
        padding: 0 4px;
        box-sizing: border-box;
    }

    .col-company {
        flex: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .col-money {
        flex: 1.2;
    }

    .col-action {
        flex: 1.6;
        text-align: center;
        white-space: nowrap;
    }
}

.distribution-header {
    font-weight: bold;
    color: #333;
    background: #f0f5ff;
    border-radius: 4px;
}

.distribution-footer {
    font-weight: bold;
    color: #333;
    background: #fffbe6;
    border-radius: 4px;
    margin-top: 4px;
}

.red {
    color: red;
}
</style>
